import axios from 'axios';

export const apiOrigin = (process.env.REACT_APP_API_URL || 'https://tandm-nur4.onrender.com').replace(/\/$/, '');

// CVs are stored either as full URLs (Cloudinary) or as legacy relative paths
// like "/uploads/cvs/..." that are served by the backend, not the frontend.
// Resolve relative paths against the API origin so links open correctly.
export const resolveAssetUrl = (url) =>
  url && url.startsWith('/') ? `${apiOrigin}${url}` : url;

const api = axios.create({
  baseURL: `${apiOrigin}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tandm_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
